import React from 'react';

const INK = {
  horizontal: '/brand/spareshub-horizontal.png',
  vertical: '/brand/spareshub-vertical.png',
  mark: '/brand/spareshub-mark.png',
};

const REVERSED = {
  horizontal: '/brand/spareshub-horizontal-light.png',
  vertical: '/brand/spareshub-vertical-light.png',
  mark: '/brand/spareshub-mark.png',
};

/**
 * SparesHub lockup. `variant`: horizontal | vertical | mark | responsive
 * (responsive = mark on phones, horizontal from sm up). `theme="dark"` uses the
 * reversed artwork for dark surfaces.
 */
export function Brand({
  variant = 'horizontal',
  theme = 'light',
  className = 'h-7 w-auto',
  testid = 'brand-logo',
}) {
  const set = theme === 'dark' ? REVERSED : INK;
  if (variant === 'responsive') {
    return (
      <>
        <img
          src={set.mark}
          alt="SparesHub"
          data-testid={testid}
          draggable={false}
          className={`sm:hidden ${className}`}
        />
        <img
          src={set.horizontal}
          alt="SparesHub"
          draggable={false}
          className={`hidden sm:block ${className}`}
        />
      </>
    );
  }
  return (
    <img
      src={set[variant] || set.horizontal}
      alt="SparesHub"
      data-testid={testid}
      draggable={false}
      className={className}
    />
  );
}
